import type { RegionalBrandCode } from '@/lib/seo/marketUrls'

export type StorefrontCurrencyCode = 'USD' | 'GBP'

/**
 * Currency row IDs used by vi-core-api and the legacy storefront.
 * Keep these aligned with dbo.Currency: 1 = GBP, 2 = USD.
 */
export const UK_STOREFRONT_CURRENCY_ID = 1
export const US_STOREFRONT_CURRENCY_ID = 2

export const STOREFRONT_CURRENCY_BY_CODE: Record<
  StorefrontCurrencyCode,
  {
    code: StorefrontCurrencyCode
    id: number
    symbol: '$' | '£'
    brandCode: RegionalBrandCode
  }
> = {
  USD: {
    code: 'USD',
    id: US_STOREFRONT_CURRENCY_ID,
    symbol: '$',
    brandCode: 'VANISHING_INC_US',
  },
  GBP: {
    code: 'GBP',
    id: UK_STOREFRONT_CURRENCY_ID,
    symbol: '£',
    brandCode: 'VANISHING_INC_UK',
  },
}

export function storefrontCurrencyForCode(
  currencyCode: string | null | undefined
) {
  const code = currencyCode?.trim().toUpperCase()
  if (code === 'USD' || code === 'GBP') {
    return STOREFRONT_CURRENCY_BY_CODE[code]
  }

  return null
}

export function storefrontCurrencyForId(currencyId: number | null | undefined) {
  if (currencyId === US_STOREFRONT_CURRENCY_ID) {
    return STOREFRONT_CURRENCY_BY_CODE.USD
  }
  if (currencyId === UK_STOREFRONT_CURRENCY_ID) {
    return STOREFRONT_CURRENCY_BY_CODE.GBP
  }

  return null
}

export function storefrontCurrencyIdForCode(
  currencyCode: string | null | undefined
) {
  return (
    storefrontCurrencyForCode(currencyCode)?.id ?? US_STOREFRONT_CURRENCY_ID
  )
}

export function storefrontCurrencySymbolForId(
  currencyId: number | null | undefined
) {
  return storefrontCurrencyForId(currencyId)?.symbol ?? ''
}

export function storefrontBrandForCurrencyId(
  currencyId: number | null | undefined
) {
  return storefrontCurrencyForId(currencyId)?.brandCode ?? null
}

export function regionalBrandDefaultCountryIso(
  brand: RegionalBrandCode
): string {
  return brand === 'VANISHING_INC_UK' ? 'GB' : 'US'
}
